import {
  SET_FIND_BUSINESS_RESULTS,
  CLEAR_FIND_BUSINESS_RESULTS,
  SET_CREDIT_MAP_RESULTS,
  CLEAR_CREDIT_MAP_RESULTS,
} from "../taskActions";

export const setFindBusinessResults = (payload) => ({
  type: SET_FIND_BUSINESS_RESULTS,
  payload,
});

export const clearFindBusinessResults = () => ({
  type: CLEAR_FIND_BUSINESS_RESULTS,
});

export const setCreditMapResults = (payload) => ({
  type: SET_CREDIT_MAP_RESULTS,
  payload,
});

export const clearCreditMapResults = () => ({
  type: CLEAR_CREDIT_MAP_RESULTS,
});
